import React from 'react';
import { useIntl } from "react-intl";
import cx from 'classnames';
import ToolTipContent from '../ToolTipContent/ToolTipContent';
import Form from 'react-bootstrap/Form'
import withStyles from 'isomorphic-style-loader/withStyles';
import bt from '../../../components/commonStyle.css';

function SelectFieldComponent(props) {

    const { label, inputClass, options, input, type, meta: { touched, error }, labelClass, showToolTip,  toolTipText, formGroupClass } = props;
    const { formatMessage } = useIntl();

    return (
        <Form.Group className={cx(bt.space0, formGroupClass)}>
            {label &&
                <Form.Label className={cx(bt.commonLabelText, 'svgImg', labelClass)}>
                    {label}&nbsp;
                    {showToolTip && <ToolTipContent label={toolTipText} />}
                </Form.Label>
            }
            <Form.Control
                {...input}
                placeholder={label}
                as="select"
                type={type}
                className={inputClass}
            >
                {options?.map((item, key) => {
                    return (
                        <option key={key} value={item?.value}>{item?.label}</option>
                    )
                })}
            </Form.Control>
            {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
        </Form.Group>
    )
}


export default withStyles(bt)(SelectFieldComponent);



